/**
 * Created by xnr on 20/2/24.
 */

import { router } from "../router";
import axios from "axios";
import qs from "qs";
import { Loading, MessageBox } from "element-ui";
import store from "../store";
import { Message } from "element-ui";
import { debounce } from "@/utils/UtilsIf"; //调用全局提示框
const Alert = debounce(msg => MessageBox.alert(msg));
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL, //测试服
  timeout: 15000 // 请求超时时间
});

let loadingInstance = null;
var aler = 0;
// request拦截器
instance.interceptors.request.use(
  e => {
    e.params = e.params || {};
    e.headers = e.headers || {};
    e.headers["Accept"] = "application/json";
    e.headers["platform"] = "PC";
    e.headers["mr-future.2022-key"] = "value-2022.mr-future";
    e.headers["SystemUpdate"] = 1;

    //导出参数
    if (e.requestBody == "download") {
      (e.responseType = "arraybuffer"), //二进制流
        (e.data = qs.stringify(e.data, { arrayFormat: "repeat" }));
    }

    // POST传参序列化
    else if (e.requestBody == "body") {
      e.headers["Content-Type"] = "application/json";
      e.data = JSON.stringify(e.data);
    } else if (e.requestBody == "upload") {
      e.headers["Content-Type"] = "multipart/form-data";
    } else {
      e.data = qs.stringify(e.data, { arrayFormat: "repeat" });
    }
    var token = store.getters.get_token;
    // var token = localStorage.getItem("set_token");
    if (token) {
      e.headers["Authorization"] = "WLXS" + " " + token.access_token;
    }
    // 自定义加载图标
    if (e.loading && !loadingInstance) {
      loadingInstance = Loading.service({
        text: "拼命请求中",
        background: "rgba(0,0,0,0.3)",
        customClass: "LoadingClass"
      });
    }
    //set 默认值
    return e;
  },
  error => ({ status: 0, msg: error.message })
);
// respone拦截器
// instance.interceptors.response.use(
//   (response) => {
//     const resp = response.data;
//     if (loadingInstance) {
//       setTimeout(function() {
//         loadingInstance && loadingInstance.close();
//         loadingInstance = null;
//       }, 300);
//     }
//     if (response.status === 200) {
//       if (resp.code == 110 && aler == 0) {
//         aler = 1;
//         MessageBox.alert("您登录已过期，请重新登录").then(() => {
//           aler = 0;
//           window.sessionStorage["vuex"] = "";
//           router.push("/Login");
//         });
//       } else {
//         return resp;
//       }
//     }
//   },
//   (error) => {
//     if (loadingInstance) {
//       setTimeout(function() {
//         loadingInstance && loadingInstance.close();
//         loadingInstance = null;
//       }, 300);
//     }
//     MessageBox.alert("您登录已过期，请重新登录").then(() => {
//       router.push({ name: "login" });
//     });
//     // eslint-disable-next-line no-console
//     console.log("err" + error); // for debug
//     return Promise.reject(error);
//   }
// );

instance.interceptors.response.use(
  response => {
    const resp = response.data;
    if (loadingInstance) {
      setTimeout(function() {
        loadingInstance && loadingInstance.close();
        loadingInstance = null;
      }, 300);
    }
    if (response.status === 200) {
      // if (resp.code == 110 && aler == 0) {
      //   aler = 1;
      //   MessageBox.alert("您登录已过期，请重新登录").then(() => {
      //     aler = 0;
      //     window.sessionStorage["vuex"] = "";
      //     router.push("/Login");
      //   });
      // } else {
      //   return resp;
      // }
      return resp;
    }
  },
  error => {
    const response = error.response;
    const resp = response ? response.data : null;
    const requestConfig =
      error.config || (response && response.config) || {};
    if (loadingInstance) {
      setTimeout(function() {
        loadingInstance && loadingInstance.close();
        loadingInstance = null;
      }, 300);
    }
    // 登录/验证码等页面级错误由调用方处理，避免抢先跳转或出现全局提示。
    if (requestConfig.skipGlobalError) {
      return Promise.reject(error);
    }
    if (!response) {
      Alert("网络请求失败");
      return Promise.reject(error);
    }
    if (response.status === 401 || response.status === 403) {
      // MessageBox.alert("您登录已过期，请重新登录");
      router.push("/Login");

      return;
    } else if (response.status === 507) {
      // MessageBox.alert("您登录已过期，请重新登录");
      router.push("/upgradeStatus");
      return;
    } else if (response.status == 400) {
      // if (resp.code === 400) {
      Alert((resp && resp.message) || "请求参数错误");
      return;
      // }
    }
    // if (resp.code !== 200) {
    //   aler = 1;
    //   MessageBox.alert(resp.message).then(() => {
    //     aler = 0;
    //     // window.sessionStorage["vuex"] = "";
    //     // router.push("/Login");
    //   });
    // }
    Alert("网络请求失败");
    return Promise.reject(error);
  }
);
// instance.interceptors.response.use(
//   (res) => {
//     //封装公共提示框
//     if (res.data.code === 200) {
//       Message({
//         message: res.message,
//         type: "success",
//       });
//     } else {
//       Message.error(res.message);
//     }
//     // 拦截下来后要做的事情
//     return res;
//   },
//   (err) => {
//     if (err.response.status === 401) {
//       router.push("/login");
//     }
//     return Promise.reject(err);
//   }
// );

export default instance;
